import { render } from "./BlogDetailComp.vue?vue&type=template&id=8d124a04"
import script from "./BlogDetailComp.vue?vue&type=script&lang=js"
export * from "./BlogDetailComp.vue?vue&type=script&lang=js"

import "./BlogDetailComp.vue?vue&type=style&index=0&id=8d124a04&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__